import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavTooltip } from '../ui/NavTooltip';

export function NavRailExpandableSection({ open, trigger, submenuId, children }) {
  return (
    <div className={`nav-rail-expandable${open ? ' nav-rail-expandable--open' : ''}`}>
      {trigger}
      <div id={submenuId} className="nav-rail-submenu" role="region" aria-hidden={!open}>
        <div className="nav-rail-submenu-inner">{children}</div>
      </div>
    </div>
  );
}

export function NavRailSubmenuItem({ icon, label, tooltip, disabled = false, onClick }) {
  const tip = tooltip || label;
  const { triggerProps, tooltip: tooltipNode } = useNavTooltip(tip);

  return (
    <>
      <Button
        {...triggerProps}
        variant="link"
        className={`nav-rail-item nav-rail-submenu-item${disabled ? ' nav-rail-submenu-item--disabled' : ''}`}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="nav-rail-item-icon">
          <div className="nav-icon-wrapper">{icon}</div>
        </span>
        <span className="nav-rail-text-slot">
          <span className="nav-rail-label">{label}</span>
        </span>
      </Button>
      {tooltipNode}
    </>
  );
}
